module.exports = __webpack_public_path__ + "static/media/message-close.1d7497fb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/message-close.svg
// module id = 1413
// module chunks = 1